<template>
	<section class="booking-benefits">
		<div class="row">
			<div class="columns column4 right bg-image-content">
				<h2>{{ footerSection.header }}</h2>
				<div v-parse-links v-html="footerSection.content" />
			</div>
			<picture>
				<source v-if="footerSection.imageWebp" :srcset="footerSection.imageWebp" type="image/webp" />
				<source :srcset="footerSection.image" />
				<img :src="footerSection.image" class="bg-image" loading="lazy" :alt="footerSection.imageAlt" />
				<img class="bg-image" :src="footerSection.image" :alt="footerSection.imageAlt" loading="lazy" />
			</picture>
		</div>
	</section>
</template>

<script setup>
defineProps({
	footerSection: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.booking-benefits {
	position: relative;
	padding: 50px 0;
	background: linear-gradient(270deg, #eeebeb 79%, #fff 21%);

	.row {
		position: relative;
		padding: 100px 20px;
	}

	ul {
		list-style: none;
		padding-left: 0;

		li {
			position: relative;
			line-height: 36px;
			vertical-align: middle;

			svg {
				margin: 0 7px 0 0;
				font-size: 20px;
				display: inline-block;
			}
		}
	}
}

.bg-image {
	position: absolute;
	inset: 0 18% 0 0;
	height: 100%;
	width: 82%;
	object-fit: cover;
	z-index: 1;
}

.bg-image-content {
	background: #fff;
	padding: 50px;
	z-index: 3;
}

@media (max-width: 600px) {
	.booking-benefits {
		background: #eeebeb;
	}
}
</style>
